










































































































































































































































































































































































































import Vue from 'vue';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';

import { State } from '@/models/State';
import DropdownOption from '@/models/misc/DropdownOption';
import CreateAgentRequest from '@/models/misc/CreateAgentRequest';
import User from '@/models/User';

import countryService from '@/services/CountryService';
import locationsService from '@/services/LocationsService';
import accountsService from '@/services/AccountsService';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin],
  /* istanbul ignore next */
  data() {
    return {
      showLoadingScreen: false,
      loadingScreenMessage: null,
      snackbar: false,
      snackbarError: false,
      snackbarText: null,
      snackbarErrorText: null,
      created: false,
      prefixTypes: ['Miss', 'Mrs', 'Mr', 'Dr'],
      selectedCountry: 'USA',
      selectedState: null,
      countriesDll: [] as DropdownOption[],
      statesDdl: [] as DropdownOption[],
      request: new CreateAgentRequest(),
      stateRules: [(v: any) => !!v || 'State is required'],
      confirmPasswordRules: [
        (v: any) => v === this.request.password || 'Passwords do not match',
      ],
      phoneFormatted: null,
      users: [] as User[],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.user && this.user.email) {
        window.location.href = '/';
      }

      locationsService.getListOfStates('USA').then((x) => {
        this.statesDdl = x.map(this.mapStates);
      });

      this.countriesDll = countryService.getAll();
      this.countryChanged('USA');

      this.request.accountId = this.$route.params.accountId;

      accountsService.getUsers(this.request.accountId).then((x: User[]) => {
        this.users = x;
      });
    },
    reverseFormat() {
      if (this.phoneFormatted)
        this.request.phone = this.phoneFormatted
          .replace('(', '')
          .replace(')', '')
          .replace(' ', '')
          .replace('-', '');
    },
    register() {
      this.reverseFormat();

      if (this.canSave) {
        if (
          this.users.find(
            (x) =>
              x.email === this.request.email ||
              x.email.includes(this.request.email)
          )
        ) {
          this.snackbarErrorText = 'User with this email already exists';
          this.snackbarError = true;
          return;
        }

        this.startLoading('Creating a user account for you!');

        accountsService
          .createUser(this.request.accountId, this.request)
          .then((x) => {
            this.created = true;

            // istanbul ignore next
            if (x.userId) {
              this.loadingScreenMessage = 'User account has been created!';

              setTimeout(() => {
                window.location.href = '/sso/login?#access_token=' + x.userId;
              }, 2000);
            } else {
              this.loadingScreenMessage = 'Sorry, somethign went wrong...';
            }
          });
      }
    },
    login() {
      window.location.href = '/';
    },
    startLoading(message) {
      this.showLoadingScreen = true;
      this.loadingScreenMessage = message;
    },
    stopLoading() {
      this.showLoadingScreen = false;
      this.loadingScreenMessage = null;
    },
    mapStates(state: State) {
      return new DropdownOption(state.name, state.id);
    },
    countryChanged(selected) {
      if (selected) {
        const country = selected.value || 'USA';
        locationsService.getListOfStates(country).then((x) => {
          this.statesDdl = x.map(this.mapStates);
        });

        this.selectedCountry = country;
        this.request.country = country;
      }
    },
    stateChanged(selected) {
      this.selectedState = selected.value;
      this.request.state = selected.value;
    },
  },
  computed: {
    canSave() {
      if (
        !this.weakPassword &&
        this.request.firstName &&
        this.request.lastName &&
        this.request.email &&
        this.request.password &&
        this.request.confirmPassword &&
        this.phoneFormatted &&
        this.request.address &&
        this.request.city &&
        this.request.state &&
        this.request.postalCode &&
        this.request.country &&
        this.request.password == this.request.confirmPassword
      )
        return true;

      return false;
    },
    weakPassword() {
      return (
        this.request.password &&
        !this.request.password.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{10,15}$/
        )
      );
    },
    matchPasswords() {
      return (
        this.request.confirmPassword && 
        !this.request.confirmPassword.match(this.request.password)
      )
    }
  },
});
